import './Scss/application.scss';
import './Scss/componentStyles';
import AppRoute from './Routes/AppRoute';
import './Components/CommonComponents/CommonStyles/global.css';
import {LanguageProvider, LANGUAGES} from './Localization/LanguageContext';
import {useLocation, useSearchParams} from 'react-router-dom';
import {useEffect} from 'react';

function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      setSearchParams({});
    } else {
      const language = localStorage.getItem('pbssLanguage');
      if (language === LANGUAGES.JA) {
        setSearchParams({language: language});
      }
    }
  }, [location.pathname, setSearchParams]);

  useEffect(() => {
    const language = searchParams.get('language');
    if (language) {
      localStorage.setItem('pbssLanguage', language);
    }
  }, [searchParams]);
  return (
    <LanguageProvider>
      <AppRoute />
    </LanguageProvider>
  );
}

export default App;
